module.exports = __webpack_public_path__ + "img/slider7.15f9544b.jpg";